'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updatePrice() {
    (0, _jquery2.default)('body').on('change', '#productSelect', function () {
        var price = (0, _jquery2.default)(this).find(':selected').data('price');
        var compare_at_price = (0, _jquery2.default)(this).find(':selected').data('compare-price');
        (0, _jquery2.default)('.product-single__price').text(price);
        (0, _jquery2.default)('.product-single__price--compare').text(compare_at_price);
    });
}

function scrollTo() {
    (0, _jquery2.default)('body').on('click', '.product-single__details', function (e) {
        e.preventDefault();
        var $productTabs = (0, _jquery2.default)('.product-tabs');
        if ($productTabs !== null) {
            var scrollToValue = document.getElementById('productTabs').getBoundingClientRect().top;
            (0, _jquery2.default)('html').animate({ scrollTop: scrollToValue }, 500);
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    updatePrice();
    scrollTo();
});

document.addEventListener('shopify:section:load', function () {
    updatePrice();
    scrollTo();
});